"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.json = exports.jsonArray = exports.jsonObject = void 0;

var _array = require("./array");

var _boolean2 = require("./boolean");

var _constants = require("./constants");

var _either = require("./either");

var _lazy = require("./lazy");

var _mapping = require("./mapping");

var _number = require("./number");

var _string = require("./string");

var jsonObject = (0, _lazy.lazy)(function () {
  return (0, _mapping.dict)(json);
});
exports.jsonObject = jsonObject;
var jsonArray = (0, _lazy.lazy)(function () {
  return (0, _array.array)(json);
});
exports.jsonArray = jsonArray;
var json = (0, _either.either6)(_constants.null_, _string.string, _number.number, _boolean2["boolean"], jsonObject, jsonArray);
exports.json = json;